var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6155 14C4.15517 14 3.77083 13.8458 3.4625 13.5375C3.15417 13.2292 3 12.8448 3 12.3845V1.6155C3 1.15517 3.15417 0.770833 3.4625 0.4625C3.77083 0.154167 4.15517 0 4.6155 0H12.3845C12.8448 0 13.2292 0.154167 13.5375 0.4625C13.8458 0.770833 14 1.15517 14 1.6155V12.3845C14 12.8448 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8448 14 12.3845 14H4.6155ZM4.6155 13H12.3845C12.5385 13 12.6796 12.9359 12.8077 12.8077C12.9359 12.6796 13 12.5385 13 12.3845V1.6155C13 1.4615 12.9359 1.32042 12.8077 1.19225C12.6796 1.06408 12.5385 1 12.3845 1H4.6155C4.4615 1 4.32042 1.06408 4.19225 1.19225C4.06408 1.32042 4 1.4615 4 1.6155V12.3845C4 12.5385 4.06408 12.6796 4.19225 12.8077C4.32042 12.9359 4.4615 13 4.6155 13ZM1.6155 17C1.15517 17 0.770833 16.8458 0.4625 16.5375C0.154167 16.2292 0 15.8449 0 15.3848V3.6155H1V15.3848C1 15.5386 1.06408 15.6796 1.19225 15.8077C1.32042 15.9359 1.4615 16 1.6155 16H10.3845V17H1.6155Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4922da633af0a5e5a6caa662e122df82.svg";
export { ForwardRef as ReactComponent };